// ** React Imports
import { Link } from "react-router-dom";

// ** Custom Components
import Avatar from "@components/avatar";

// ** Third Party Components
import { Power } from "react-feather";

// ** Reactstrap Imports
import {
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

// ** Default Avatar Image
import defaultAvatar from "@src/assets/images/portrait/small/avatar-s-11.jpg";

import { signoutRedirect } from "../../../../services/userService";

const UserDropdown = () => {
  function signOut() {
    signoutRedirect();
  }

  const renderClient = (person) => {
    const stateNum = Math.floor(Math.random() * 6);
    let color = "";
    let name = "";
    const states = [
      "light-success",
      "light-danger",
      "light-warning",
      "light-info",
      "light-primary",
      "light-secondary",
    ];

    if (person?.firstName !== null) {
      color = states[stateNum];
      name = person?.firstName
        .split(" ")[0]
        .concat(" ", person?.lastName.split(" ")[0]);
    }

    if (person) {
      return (
        <Avatar
          color={color !== "" ? color : "light-primary"}
          content={person?.firstName ? name.toUpperCase() : "Sin Nombre"}
          initials
        />
      );
      return <Avatar />;
    }
  };

  const data = JSON.parse(localStorage.getItem("profile"));

  return (
    <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link dropdown-user-link"
        onClick={(e) => e.preventDefault()}
      >
        <div className="user-nav d-sm-flex d-none">
          <span className="user-name fw-bold">
            {data?.firstName ? data?.firstName : "John "}
            {data?.middleName ? data?.middleName : ""}
            {data?.lastName ? data?.lastName : "Doe"}
          </span>
        </div>
        {renderClient(data)}
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem tag={Link} to="/" onClick={signOut}>
          <Power size={14} className="me-75" />
          <span className="align-middle">Cerrar sesión</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default UserDropdown;
